import { Auditable, QueryParams, SortParams } from "..";

export interface CaseFileCategory extends Auditable {
    name: string;
}

export const DefaultCaseFileCategoryQueryParams: QueryParams = {
    name: "",
};

export const DefaultCaseFileCategorySortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};

// compare to business microservice/Resources/CaseFiles/DefaultCaseFileCategories.cs
export enum CaseFileCategories {
    FormAttachments = "Form Attachments",
    ReferralRecordings = "Referral Recordings",
    ReferralDocuments = "Referral Documents",
    TissueGrading = "Tissue Grading",
    TissuePostProcessing = "Tissue Post-Processing",
    TissuePlacement = "Tissue Placement",
    TissueOther = "Tissue Other",
}
